import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { NotificationService } from "src/helpers/notifications";
import { errorResponsesTrns } from "src/translate/responses";
import { ISelectOption } from "src/@types/form";

export const PRICES_SLICE_NAME = "prices";

export const getPricesAsync = createAsyncThunk(
  `${PRICES_SLICE_NAME}/fetchPrices`,
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await instance.get<ISelectOption[]>(
        "/clones/list-options/"
      );

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error || errorResponsesTrns.prices;

      NotificationService.error(errorText);

      return rejectWithValue(errorText);
    }
  }
);
